import React, { useState } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import theme from '../../../common/theme'
import moment from 'moment'
import MonthYear from '../../../common/MonthYear'
import { declarationData } from './DeclarationPage'
import { createDeclaration } from '../../services/declaration-services'
import Icon from '../../../common/Icon';

const Container = styled.div`
  display: flex;
  background-color: ${theme.palette.light_grey};
  padding: 10px 20px;
  justify-content: space-between;
  
  &.active {
      cursor: pointer;
      &:hover {
        background-color: ${ theme.palette.grey };
      }
    }
  
  > .link {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-decoration: underline;
  }
`

export default function DeclarationLine({ month, ...props }) {

  const history = useHistory()

  const [actionDisable, setActionDisabled] = useState(false)

  const declare = async () => {
    // Avoid double creation
    if (!actionDisable) {
      setActionDisabled(true)

      if (!month.declaration) {
        const declarationInput = `
        recordId: "${month.recordId}"
        period: "${month.period}"
      `
        const response = await createDeclaration(declarationInput, declarationData)
        month.declaration = response.data.createDeclaration
      }

      history.push({
        pathname: '/declare',
        state: {month}
      })
      return true
    }
  }

  let content
  if (month.canDeclare) {
    content = <span className="link">Je déclare mes frais<Icon name="chevron_right" /></span>
  } else if (month.declaration) {
    content = <span>{ month.declaration.hours } heures déclarées {
      (month.declaration && !month.declaration.basageId) && `le ${month.declaration.declareDate ? moment(month.declaration.declareDate).format('DD MMM YYYY') : ''}`}</span>
  } else {
    content = <span>Non déclaré</span>
  }

  const className = month.canDeclare ? 'active' : ''
  const action = month.canDeclare ? declare : null

  return <Container className={className} onClick={action}>
    <MonthYear date={ month.date._d } />
    { content }
  </Container>
}
